import script from "./MainRequestDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainRequestDetailView.vue?vue&type=script&setup=true&lang=js"

import "./MainRequestDetailView.vue?vue&type=style&index=0&id=a1b35630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1b35630"]])

export default __exports__